import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Tracker from "@/pages/Tracker";
import Timeline from "@/pages/Timeline";
import EntryDetail from "@/pages/EntryDetail";
import Categories from "@/pages/Categories";
import Jurisdictions from "@/pages/Jurisdictions";
import Submit from "@/pages/Submit";
import About from "@/pages/About";
import SharedSearch from "@/pages/SharedSearch";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEntryForm from "@/pages/admin/AdminEntryForm";
import AdminTips from "@/pages/admin/AdminTips";
import AdminEditors from "@/pages/admin/AdminEditors";
import AdminDigest from "@/pages/admin/AdminDigest";
import Admin2FA from "@/pages/admin/Admin2FA";
import AdminCitationAudit from "@/pages/admin/AdminCitationAudit";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminIngest from "@/pages/admin/AdminIngest";
import AdminEditorStats from "@/pages/admin/AdminEditorStats";
import AdminAgent from "@/pages/admin/AdminAgent";
import AdminAgentRun from "@/pages/admin/AdminAgentRun";
import JurisdictionDetail from "@/pages/JurisdictionDetail";
import Compare from "@/pages/Compare";
import RequireAdmin from "@/components/RequireAdmin";
import { AuthProvider } from "@/contexts/AuthContext";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <Helmet defaultTitle="Receipts — Women's Rights Accountability Tracker">
          <meta property="og:site_name" content="Receipts" />
          <meta name="twitter:site" content="@receipts" />
          {/* Feed auto-discovery — readers like Feedly/Inoreader pick these up automatically */}
          <link rel="alternate" type="application/rss+xml" title="Receipts — RSS" href="/api/feed.xml" />
          <link rel="alternate" type="application/feed+json" title="Receipts — JSON Feed" href="/api/feed.json" />
        </Helmet>
        <BrowserRouter>
        <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tracker" element={<Tracker />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/entry/:id" element={<EntryDetail />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/:slug" element={<Tracker />} />
            <Route path="/jurisdictions" element={<Jurisdictions />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/about" element={<About />} />
            <Route path="/share/:token" element={<SharedSearch />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="/admin/new" element={<RequireAdmin><AdminEntryForm /></RequireAdmin>} />
            <Route path="/admin/edit/:id" element={<RequireAdmin><AdminEntryForm /></RequireAdmin>} />
            <Route path="/admin/tips" element={<RequireAdmin><AdminTips /></RequireAdmin>} />
            <Route path="/admin/editors" element={<RequireAdmin><AdminEditors /></RequireAdmin>} />
            <Route path="/admin/digest" element={<RequireAdmin><AdminDigest /></RequireAdmin>} />
            <Route path="/admin/2fa" element={<RequireAdmin><Admin2FA /></RequireAdmin>} />
            <Route path="/admin/audit" element={<RequireAdmin><AdminCitationAudit /></RequireAdmin>} />
            <Route path="/admin/audit-log" element={<RequireAdmin><AdminAuditLog /></RequireAdmin>} />
            <Route path="/admin/ingest" element={<RequireAdmin><AdminIngest /></RequireAdmin>} />
            <Route path="/admin/agent" element={<RequireAdmin><AdminAgent /></RequireAdmin>} />
            <Route path="/admin/agent/runs/:id" element={<RequireAdmin><AdminAgentRun /></RequireAdmin>} />
            <Route path="/admin/editor-stats" element={<RequireAdmin><AdminEditorStats /></RequireAdmin>} />
            <Route path="/jurisdictions/:name" element={<JurisdictionDetail />} />
            <Route path="/compare" element={<Compare />} />
          </Route>
        </Routes>
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
